<template>
	<v-layout class="column carousel-slider-container">
		<ItemMenuSlider :key="inner_carusel" v-if="makeReportsActive" />
		<router-view :key="router_view" v-if="!makeReportsActive"></router-view>
	</v-layout>
</template>

<script>
import ItemMenuSlider from '@/components/carousel/ItemMenuSlider';

export default {
	name: 'Report',
	components: {
		ItemMenuSlider,
	},
	computed: {
		makeReportsActive(){
			let isactive = true
			if (
				this.$route.name == 'MakeReport'
			) {
				isactive = false
			}
			return isactive
		}
	},
	methods: {
		/* makeReportsActive() {
			if (
				this.$route.path == '/report/makereport' ||
				this.$route.path == '/report/viewmyreport' ||
				this.$route.path == '/report/viewreport'
			) {
				return false;
			} else {
				return true;
			}
		}, */
	},
	mounted() {
		//this.makeReportsActive();
	},
	data() {
		return {
			inner_carusel: 1000,
			router_view: 2000,
			footer_button: 3000,
			//go_to: '/report',
		};
	},
};
</script>

<style scope lang="scss" src="./Raport.scss"></style>
